export const bonuses = [
  {
    number: 1,
    title: 'The TRT Initial Assessment Checklist',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/xi84J6Y2ekpjAupMkEFwxE/BONUS_1_TRTBP-EN.png',
    description: 'A structured checklist to help you organize the information that may be relevant during an initial assessment.',
    items: [
      'Relevant history prompts.',
      'Symptom assessment considerations.',
      'Diagnostic confirmation reminders.',
      'Baseline evaluation prompts.',
      'A pre-decision review checklist.',
    ],
    why: 'It gives you a structured way to review the initial assessment instead of relying solely on memory.',
  },
  {
    number: 2,
    title: 'The Testosterone Lab Review Toolkit',
    value: 39,
    image: 'https://cdn.magicpatterns.com/uploads/kHXzGzfGcErLXCSdPBQptJ/BONUS_2_TRTBP-EN.png',
    description: 'A companion resource for organizing laboratory findings and the questions they raise.',
    items: [
      'A laboratory review worksheet.',
      'A total testosterone interpretation reference.',
      'An overview of SHBG and free testosterone considerations.',
      'A guide to relevant secondary investigations.',
      'A checklist of common interpretive pitfalls.',
    ],
    why: 'It helps you organize laboratory information within the wider clinical context.',
  },
  {
    number: 3,
    title: 'The TRT Safety & Monitoring Checklist Pack',
    value: 39,
    image: 'https://cdn.magicpatterns.com/uploads/vvisBoQb2XJPaVc2cXshcG/BONUS_3_TRTBP-EN.png',
    description: 'A collection of checklists covering key safety and follow-up considerations.',
    items: [
      'Baseline safety review prompts.',
      'Hematocrit monitoring considerations.',
      'Prostate-related assessment prompts, where applicable.',
      'Adverse-effect review prompts.',
      'Follow-up documentation templates.',
    ],
    why: 'It provides an organized reference for reviewing safety considerations throughout the treatment journey.',
  },
  {
    number: 4,
    title: 'The TRT Patient Consultation Scriptbook',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/kqtjtw8C1PJoffzdzAKbNS/BONUS_4_TRTBP-EN.png',
    description: 'A collection of educational conversation frameworks to help you explain the evaluation and treatment process more clearly.',
    items: [
      'A framework for explaining the diagnostic process.',
      'Questions to explore patient expectations.',
      'A guide to discussing potential benefits and limitations.',
      'Conversation prompts for fertility considerations.',
      'A framework for discussing risks, monitoring, and shared decision-making.',
    ],
    why: 'It helps you structure patient conversations without relying on improvised explanations.',
  },
  {
    number: 5,
    title: 'The TRT Clinical Quick-Reference Pack',
    value: 39,
    image: 'https://cdn.magicpatterns.com/uploads/1YzKqcoPh3LgKqqSnLAs7G/BONUS_5_TRTBP-EN.png',
    description: 'A concise collection of visual references designed for rapid consultation.',
    items: [
      'A visual overview of the clinical workflow.',
      'An evaluation-stage reference map.',
      'A treatment-planning overview.',
      'A monitoring reference sheet.',
      'A clinical documentation checklist.',
    ],
    why: 'It brings key educational concepts together in a format that’s easy to scan and revisit.',
  },
];
